export default __webpack_public_path__ + "static/Products_Placeholder_5.0-8d40d6fb12388cb5c26d26b2e1c6a28c.jpg";